/*
 * @Description: 实时定位驾驶舱 — B3「单成员完整轨迹」数据 hook（个人轨迹回放）
 */
import { useEffect, useRef, useState } from 'react'
import { useAppDispatch } from '../../../app/hooks'
import { fetchTrackTimeline } from '../../../actions/locationCockpit'
import { isCockpitMockEnabled } from '../constants'
import { getMockTimeline } from '../mock/timeline.mock'
import { CockpitEnvelope, TimelineData } from '../types/cockpit.types'

export interface UseTrackTimelineResult {
  timeline: TimelineData | null
  loading: boolean
}

/**
 * 拉取单成员当日完整轨迹（B3）。userId/date 变化时重新拉取。
 *
 * @param groupId - 当前团队长 id
 * @param userId - 成员 userId
 * @param date - 日期 YYYY-MM-DD
 */
export function useTrackTimeline(
  groupId: string,
  userId: string,
  date: string
): UseTrackTimelineResult {
  const dispatch = useAppDispatch()
  const isMock = isCockpitMockEnabled()
  const [timeline, setTimeline] = useState<TimelineData | null>(null)
  const [loading, setLoading] = useState(false)
  const aliveRef = useRef(true)

  useEffect(() => {
    aliveRef.current = true

    if (isMock) {
      setTimeline(getMockTimeline())
      return () => {
        aliveRef.current = false
      }
    }
    if (!groupId || !userId || !date) {
      return () => {
        aliveRef.current = false
      }
    }

    setLoading(true)
    dispatch(fetchTrackTimeline({ groupId, userId, date }))
      .then((res: CockpitEnvelope<TimelineData>) => {
        if (!aliveRef.current) return
        setLoading(false)
        if (res && res.code === 200) {
          setTimeline(res.data ?? null)
        }
      })
      .catch(() => {
        if (!aliveRef.current) return
        setLoading(false)
      })

    return () => {
      aliveRef.current = false
    }
  }, [dispatch, groupId, userId, date, isMock])

  return { timeline, loading }
}
